import { websiteEnv } from './website-env';

let sizeMap = {
  0: 'US0',
  2: 'US2',
  4: 'US4',
  6: 'US6',
  8: 'US8',
  10: 'US10',
  12: 'US12',
  14: 'US14',
  16: 'US16',
  18: 'US18',
  20: 'US20',
  22: 'US22',
  24: 'US24',
  26: 'US26',
  28: 'US28',
  30: 'US30',
};

if (websiteEnv.isUnitedKingdom || websiteEnv.isIreland) {
  sizeMap = {
    0: 'UK4',
    2: 'UK6',
    4: 'UK8',
    6: 'UK10',
    8: 'UK12',
    10: 'UK14',
    12: 'UK16',
    14: 'UK18',
    16: 'UK20',
    18: 'UK22',
    20: 'UK24',
    22: 'UK26',
    24: 'UK28',
    26: 'UK30',
    28: 'UK32',
    30: 'UK34',
  };
} else if (websiteEnv.isAustralia || websiteEnv.isNewZealand) {
  sizeMap = {
    0: 'AU4',
    2: 'AU6',
    4: 'AU8',
    6: 'AU10',
    8: 'AU12',
    10: 'AU14',
    12: 'AU16',
    14: 'AU18',
    16: 'AU20',
    18: 'AU22',
    20: 'AU24',
    22: 'AU26',
    24: 'AU28',
    26: 'AU30',
    28: 'AU32',
    30: 'AU34',
  };
} else if (websiteEnv.isGermanyEnglish) {
  sizeMap = {
    0: 'EU32',
    2: 'EU34',
    4: 'EU36',
    6: 'EU38',
    8: 'EU40',
    10: 'EU42',
    12: 'EU44',
    14: 'EU46',
    16: 'EU48',
    18: 'EU50',
    20: 'EU52',
    22: 'EU54',
    24: 'EU56',
    26: 'EU58',
    28: 'EU60',
    30: 'EU62',
  };
}

export { sizeMap };
